<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid="">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
            ><b-icon-trash animation="fade"></b-icon-trash> Reporte de ingresos
            con Proyección y Objetivos</span
          >
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_01_RI_DIC</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <br />
          <br />
          <br />
        </b-col>
      </b-row>

      <b-row>
        <b-col> </b-col>
        <b-col>
          <label>Fecha Inicio:</label>
          <br />
          <b-form-datepicker
            v-if="$localStorageService.can('RI_01_rp_ingreso_fecha')"
            inline
            v-model="fechaInicio"
            placeholder="Selecciona una fecha"
            @input="cambiarFecha()"
          ></b-form-datepicker>
          <br />
          <b-button 
          v-if="$localStorageService.can('RI_01_rp_ingreso_consultar')"
          block variant="info" @click="getReporteIngresosProyeccion"
            >Consultar</b-button
          >
        </b-col>
        <b-col> </b-col>
      </b-row>

      <b-row>
        <b-col>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </b-col>
      </b-row>
 
      <b-row> 
        <b-col>
          <b-table
            thead-tr-class="columnas"
            :items="datosReporteIngresos"
            :fields="encabezadosTabla"
            responsive
          >
            <!-- <template v-slot:cell(totalFecha)>
                      <div>
                        {{ this.fechaInicio | formatoFechaHora }}
                      </div>
                    </template>  -->
          </b-table>
        </b-col> 
      </b-row>

      <b-row>
        <b-col>
          <br /><br /><br /><br /><br /><br />
          <br />
          <br />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <br /><br /><br /><br /><br /><br />
          <br />
          <br />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "ReporteIngresoConProyeccionYObjetivos",
  components: {
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fechaInicio: "",
    fechaDefault: "",
    datosReporteIngresos: [],
    loading: false,
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    encabezadosTabla: [
      {
        key: "concepto",
        label: "Concepto",
      },
      {
        key: "totalFecha",
        label: "",
      },
      {
        key: "totalAcumuladoMes",
        label: "Total Acumulado del Mes",
      },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();

    this.fechaDefault = this.$moment(new Date()).format(
      "YYYY-MM-DD[T]HH:mm:ss[Z]"
    ); 
    this.fechaInicio = this.fechaDefault;

    this.encabezadosTabla[1]["label"] = "Ingresos del " + this.$moment(new Date()).format(
      "DD-MM-YYYY"
    );
  },
  methods: {
    getReporteIngresosProyeccion() {
      var fechaIni = this.$moment(this.fechaInicio).format(
        "YYYY-MM-DD[T]HH:mm:ss[Z]"
      );

      this.loading = true;
      this.datosReporteIngresos = [];
      const parametros = {fechaInicio: fechaIni}
      this.$http
        .post(
          this.$api +
            "finanzas/reporte/ingresos/proyeccion", parametros
        )
        .then((response) => {
          if (response.data.data) {
            if (Array.isArray(response.data.data) == true) {
              this.datosReporteIngresos = response.data.data; 
              this.encabezadosTabla[1]["label"] = "Ingresos del " + this.$moment(this.fechaInicio).format("DD-MM-YYYY");
            }
          }
        })
        .catch(function (error) {
          console.error(error);
          console.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cambiarFecha(){ 
        this.encabezadosTabla[1]["label"] = "Ingresos del " +  this.$moment(this.fechaInicio).format("DD-MM-YYYY");
    },

    //finaliza methods
  },




};
</script>

<style scoped>
</style>
